import React from 'react';
import PropTypes from 'prop-types';
import ReduxActions from 'reduxActions';
import { connect } from 'react-redux';
import { Components, Utils, translate } from 'versafleet-core';

const TaskBulkArchiveButton = ({
  id = '',
  dataIds,
  dispatch,
  strings,
}) => (
  <Components.Archive
    archive={async () => {
      if (!Utils.Helper.isNullOrUndefined(dataIds) && dataIds.length > 0) {
        await dispatch(ReduxActions.task.archiveMultiple(dataIds));
      }
    }}
    archivePath={() => Utils.Router.transitionTo('/archives/tasks')}
    delete={async () => {
      const action = dataIds.length > 1
        ? ReduxActions.task.multipleDelete(dataIds)
        : ReduxActions.task.delete(dataIds[0]);
      await dispatch(action);
    }}
    ids={dataIds}
    modelName={strings.constants.task}
    updateContent={() => { dispatch(ReduxActions.task.fetchList()); }}
  >
    <Components.Button
      className="vf-task__bulk-archive-button"
      hint={strings.page.buttons.archive}
      iconClassName="versa-archive"
      id={id}
    />
  </Components.Archive>
);

TaskBulkArchiveButton.displayName = 'Task Bulk Archive Button';

TaskBulkArchiveButton.propTypes = {
  dataIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  strings: PropTypes.shape({
    constants: PropTypes.shape({
      task: PropTypes.string,
    }),
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        archive: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default connect()(translate('Task')(TaskBulkArchiveButton));
